module.exports = __webpack_public_path__ + "b99be94f1ad3cf49975e0d9ad69836e9.wav";